const ServiceCard = [{
        id: 1,
        title: "Stabilité dans les moments de turbulence",
        description: "Restez maître de vos réactions, même sous pression.",
    },
    {
        id: 2,
        title: "Énergie créative renouvelée",
        description: "Avancez avec clarté, élan et fluidité.",
    },
    {
        id: 3,
        title: "Relations profondes et authentiques",
        description: "Créez de la sécurité dans vos relations, communiquez avec impact.",
    },
    {
        id: 4,
        title: "Décisions stratégiques et alignées",
        description: "Faites des choix cohérents avec vos valeurs et vos priorités.",
    },
    {
        id: 5,
        title: "Performance durable et équilibrée",
        description: "Alliez excellence et bien-être. Avancez sereinement.",
    },
]

const entrepreneursCards =
         [
                {
                    id: 1,
                    title: "Comprendre vos schémas de réaction",
                    description: "Décoder vos réponses automatiques face à la pression."
                },
                {
                    id: 2,
                    title: "Maîtriser les signaux de votre système nerveux",
                    description: "Identifier les leviers d’équilibre."
                },
                {
                    id: 3,
                    title: "Appliquer des stratégies pratiques et personnalisées",
                    description: "Basées sur les neurosciences et l’intelligence émotionnelle."
                },
                {
                    id: 4,
                    title: "Développer un leadership authentique",
                    description: "Depuis un Centre équilibré, et non une surcharge cognitive."
                },
                {
                    id: 5,
                    title: "Créer une performance durable",
                    description: "Ancrée dans un capital intérieur régulé par votre Centre."
                },
            ]

export {
    ServiceCard,
    entrepreneursCards
}